// extracted by mini-css-extract-plugin
export var animationContainer = "_p5-0";
export var footer = "_p5-1";
export var gray = "_p5-2";
export var lineItem = "_p5-3";
export var lineItemImage = "_p5-4";
export var lineItemInfo = "_p5-5";
export var lineItemText = "_p5-6";
export var lineItems = "_p5-7";
export var modalContent = "_p5-8";
export var options = "_p5-9";
export var orderName = "_p5-a";
export var refundAmount = "_p5-b";